import * as React from 'react';
import { SkeletonLoadingWrapper, MarginTop } from '@helpcenter/loading';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
import { withFadeIn } from 'view/common/with-fade-in';

const MarginWrapper = () => {
    return (
        <MarginTop>
            <SkeletonLoadingWrapper />
        </MarginTop>
    );
};

const loader = lazyForPaint(
    () =>
        import(/* webpackChunkName: "request-create-form" */ './request-create-form-dumb').then((module) =>
            withFadeIn()(module.default)
        ),
    {
        ssr: true,
    }
);

export default withAsync({
    loader,
    loadingPosition: 'static',
    LoadingSkeleton: MarginWrapper,
});
